import { IconProps } from 'types/icon.type'

export const HeartFavoriteIcon = (props: IconProps) => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
     
      <mask
        id="mask0_322_533"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="8"
        y="9"
        width="30"
        height="30"
      >
        <rect x="8" y="9" width="30" height="30" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_322_533)">
        <path
          d="M22.9881 33.6369C22.7204 33.6369 22.4516 33.5889 22.1816 33.4928C21.9116 33.3966 21.674 33.2459 21.4688 33.0409L19.6731 31.4087C17.4569 29.3879 15.4781 27.4027 13.7369 25.4531C11.9956 23.5035 11.125 21.415 11.125 19.1875C11.125 17.4135 11.7231 15.9283 12.9194 14.7319C14.1158 13.5356 15.601 12.9375 17.375 12.9375C18.3829 12.9375 19.3785 13.1699 20.3619 13.6347C21.345 14.0995 22.2244 14.8543 23 15.8991C23.7756 14.8543 24.655 14.0995 25.6381 13.6347C26.6215 13.1699 27.6171 12.9375 28.625 12.9375C30.399 12.9375 31.8842 13.5356 33.0806 14.7319C34.2769 15.9283 34.875 17.4135 34.875 19.1875C34.875 21.4392 33.9896 23.5509 32.2188 25.5228C30.4479 27.4947 28.4735 29.463 26.2956 31.4278L24.5191 33.0409C24.3141 33.2459 24.0746 33.3966 23.8006 33.4928C23.5265 33.5889 23.2556 33.6369 22.9881 33.6369Z"
          fill={props.color}
          fillOpacity="0.79"
        />
        <mask
          id="mask1_322_533"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="8"
          y="9"
          width="30"
          height="30"
        >
          <rect x="8" y="9" width="30" height="30" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask1_322_533)">
          <path
            d="M22.9881 33.6369C22.7204 33.6369 22.4516 33.5889 22.1816 33.4928C21.9116 33.3966 21.674 33.2459 21.4688 33.0409L19.6731 31.4087C17.4569 29.3879 15.4781 27.4027 13.7369 25.4531C11.9956 23.5035 11.125 21.415 11.125 19.1875C11.125 17.4135 11.7231 15.9283 12.9194 14.7319C14.1158 13.5356 15.601 12.9375 17.375 12.9375C18.3829 12.9375 19.3785 13.1699 20.3619 13.6347C21.345 14.0995 22.2244 14.8543 23 15.8991C23.7756 14.8543 24.655 14.0995 25.6381 13.6347C26.6215 13.1699 27.6171 12.9375 28.625 12.9375C30.399 12.9375 31.8842 13.5356 33.0806 14.7319C34.2769 15.9283 34.875 17.4135 34.875 19.1875C34.875 21.4392 33.9896 23.5509 32.2188 25.5228C30.4479 27.4947 28.4735 29.463 26.2956 31.4278L24.5191 33.0409C24.3141 33.2459 24.0746 33.3966 23.8006 33.4928C23.5265 33.5889 23.2556 33.6369 22.9881 33.6369ZM22.1009 17.7981C21.4247 16.7677 20.7127 16.0125 19.965 15.5325C19.2175 15.0525 18.3542 14.8125 17.375 14.8125C16.125 14.8125 15.0833 15.2292 14.25 16.0625C13.4167 16.8958 13 17.9375 13 19.1875C13 20.1906 13.3233 21.2395 13.97 22.3341C14.6167 23.4286 15.4283 24.5168 16.405 25.5984C17.3817 26.6803 18.4398 27.7372 19.5794 28.7691C20.7188 29.8011 21.7748 30.7603 22.7475 31.6466C22.8196 31.7107 22.9038 31.7428 23 31.7428C23.0962 31.7428 23.1804 31.7107 23.2525 31.6466C24.2252 30.7603 25.2813 29.8011 26.4206 28.7691C27.5602 27.7372 28.6183 26.6803 29.595 25.5984C30.5717 24.5168 31.3833 23.4286 32.03 22.3341C32.6767 21.2395 33 20.1906 33 19.1875C33 17.9375 32.5833 16.8958 31.75 16.0625C30.9167 15.2292 29.875 14.8125 28.625 14.8125C27.6458 14.8125 26.7825 15.0525 26.035 15.5325C25.2873 16.0125 24.5753 16.7677 23.8991 17.7981C23.7932 17.9583 23.6602 18.0785 23.5 18.1588C23.3398 18.2387 23.1731 18.2787 23 18.2787C22.8269 18.2787 22.6602 18.2387 22.5 18.1588C22.3398 18.0785 22.2068 17.9583 22.1009 17.7981Z"
            fill="white"
          />
        </g>
      </g>
    </svg>
  )
}
